const GetProxy = (useApiPath = true) => {
  const baseUrl = window.BE_URL;
  const proxy = useApiPath ? `${baseUrl}/api/v1` : baseUrl;
  return proxy;
};

export default GetProxy;